<template>
  <v-col cols="12">
    <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
      <v-card color="white" dark class="rounded-xl">
        <v-card-title class="text-h5" style="color: #6b6868">
          <v-icon style="padding-right: 0.3em; color: #6b6868"
            >mdi-account-details-outline</v-icon
          >
          Informations personnelles
        </v-card-title>

        <v-card-subtitle>
          <v-alert
            outlined
            type="success"
            prominent
            border="left"
            text
            style="margin-top: 1em"
            v-if="personalInfosIsUpdated === true"
          >
            Vos informations personnelles ont bien été mises à jour.
          </v-alert>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            style="margin-top: 1em"
            v-if="formErrors.length > 0"
          >
            <b>Veuillez corriger les erreurs suivantes:</b>
            <ul>
              <li v-for="(error, index) in formErrors" :key="index">
                • {{ error }}
              </li>
            </ul>
          </v-alert>
          <section
            style="
              background: rgba(255, 255, 255, 0.9);
              color: #777171;
              padding: 1em;
            "
          >
            <v-form>
              <v-row class="pa-5">
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Nom"
                    v-model="formFields.lastname"
                    placeholder="Ex: SACKO"
                    prepend-inner-icon="mdi-card-account-details-outline"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Prénoms"
                    v-model="formFields.firstname"
                    placeholder="Ex: Mohamed Kounda"
                    prepend-inner-icon="mdi-card-account-details"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Email"
                    placeholder="Ex: exemple@exemple.fr"
                    v-model="formFields.email"
                    prepend-inner-icon="mdi-at"
                    disabled
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Numéro de téléphone"
                    v-model="formFields.phoneNumber"
                    placeholder="Ex: 624 99 99 99"
                    prepend-inner-icon="mdi-cellphone-sound"
                    light
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" offset-md="4" md="4" sm="12" xs="12">
                  <v-btn
                    class="col-12"
                    color="success"
                    rounded
                    v-on:click="updateUserInfos"
                  >
                    <v-icon left> mdi-content-save-all-outline </v-icon>
                    Mettre à jour
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "PersonalInformationForm",
  data: function () {
    return {
      personalInfosIsUpdated: false,
      formFields: {
        firstname: null,
        lastname: null,
        phoneNumber: null,
        email: null,
      },
      currentUserInfos: {},
      menu: false,
      show1: false,
      formErrors: [],
    };
  },
  methods: {
    checkForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (
        !this.formFields.firstname ||
        this.formFields.firstname.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Le prénom est obligatoire.");
      }

      if (!this.formFields.lastname || this.formFields.lastname.trim() === "") {
        isValid = false;
        this.formErrors.push("Le nom est obligatoire.");
      }

      if (
        !this.formFields.phoneNumber ||
        this.formFields.phoneNumber.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Votre numéro de téléphone est obligatoire.");
      }

      return isValid;
    },

    updateUserInfos: function () {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        httpClient
          .updateUserInformations(
            {
              firstname: this.formFields.firstname,
              lastname: this.formFields.lastname,
              gender: this.formFields.gender,
              id: this.currentUserInfos.id,
              birthday: this.formFields.birthdate,
              phoneNumber: this.formFields.phoneNumber,
            },
            localStorage.getItem("jwt-token")
          )
          .then((value) => {
            localStorage.setItem("currentUser", JSON.stringify(value.data));
            this.personalInfosIsUpdated = true;
            setTimeout(
              function () {
                this.personalInfosIsUpdated = false;
              }.bind(this),
              4000
            );
          })
          .catch((reason) => {
            if (reason.response.status === 401) {
              this.$router.push("/logout");
            }
            this.formErrors = [];
            this.formErrors.push("Une erreur s'est produite");
          });
      }
    },
  },
  created() {
    const httpClient = new HttpClient();
    httpClient
      .getCurrentUserInformations(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.currentUserInfos = value.data;
        this.formFields.lastname = value.data.lastname;
        this.formFields.firstname = value.data.firstname;
        this.formFields.phoneNumber = value.data.phoneNumber;
        this.formFields.email = value.data.email;
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push("/logout");
        }
      });
  },
});
</script>

<style scoped></style>
